import { sellerToPathNameMap } from './getSeller';
export const getOssToPathNameMap = {
    ...sellerToPathNameMap,
};
